var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotes23(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.959 5.944h-1.686a2.512 2.512 0 0 1-2.508-2.508V1.75a.585.585 0 0 0-.584-.583H4.708c-1.797 0-3.249 1.166-3.249 3.249v5.168c0 2.083 1.452 3.25 3.25 3.25h4.584c1.797 0 3.25-1.167 3.25-3.25V6.528a.585.585 0 0 0-.584-.584z",
    fill: "#979797"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.216 1.29c-.24-.24-.653-.077-.653.256v2.036c0 .851.723 1.557 1.604 1.557.554.006 1.324.006 1.983.006.332 0 .508-.39.274-.624-.84-.846-2.345-2.369-3.208-3.232zM7.875 8.02h-3.5a.44.44 0 0 1-.438-.437.44.44 0 0 1 .438-.437h3.5a.44.44 0 0 1 .438.437.44.44 0 0 1-.438.438zM6.708 10.354H4.375a.44.44 0 0 1-.438-.437.44.44 0 0 1 .438-.438h2.333a.44.44 0 0 1 .438.438.44.44 0 0 1-.438.437z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes23);
export default __webpack_public_path__ + "static/media/notes23.01da58c58482afa1e44d52b9acd1b18b.svg";
export { ForwardRef as ReactComponent };